/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2024-10-25 15:31:29
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2024-10-25 15:32:35
 * @FilePath: \game2\src\utils\initFaceBookSdk.js
 */
import Base from "./base";

// 根据appid 动态引入facebook sdk script
const urlData = Base.parseUrl(window.location.href); // canshu

let appid = "4171665012929338";
if (urlData.appid == "105409") {
  appid = "796559589311809";
}
var script = document.createElement("script");
script.src =
  "https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v3.3&appId=" +
  appid +
  "&autoLogAppEvents=1";
script.defer = true;
script.async = true;
script.crossOrigin = "anonymous";
document.head.appendChild(script);
